import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-room-equipment-badge',
  imports: [],
  templateUrl: './room-equipment-badge.component.html',
  styleUrl: './room-equipment-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomEquipmentBadgeComponent {
  @Input() name: string = '';
  @Input() size: 'sm' | 'xs' = 'xs';
}
